import React from 'react';
import logo from '../../assets/images/logo.png';
import moment from 'moment';
import { Page, Text, View, Image, Link, Document, StyleSheet, Font } from '@react-pdf/renderer';
import { dayNumber } from '../../helpers';
import { getIconForDaysType } from '../icon-days-type';

Font.register({
  family: "Roboto",
  src: "https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Me5Q.ttf",
});

const styles = StyleSheet.create({
    page: {
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 60,
        paddingBottom: 35,
        fontFamily: "Roboto",
    },
    section: {
        flexGrow: 1
    },
    footer: {
        position: "absolute",
        fontSize: 8,
        bottom: 0,
        left: 0,
        right: 0,
        paddingTop: 10,
        paddingBottom: 10,
        borderTop: "1px solid #ced4da",
        textAlign: "center",
        color: "#555"
    },
    header: {
        position: "absolute",
        fontSize: 8,
        top: 0,
        left: 0,
        right: 0,
        borderBottom: "1px solid #ced4da",
        textAlign: "center",
        color: "#555",
        display: "flex",
        flexDirection: 'row',
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 5,
        paddingBottom: 5
    },
    headertxt: {
        fontSize: 9,
        color: "#555",
        marginTop: 2,
        marginBottom: 2,
    },
    headerlogo: {
        width: 50,
        height: 50,
        objectFit: "contain",
    },
    itemlist: {
        backgroundColor: "#E2F1FA",
        borderRadius: "3px",
        padding: 8,
        marginTop: 10,
        display: "flex",
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    itemlogo: {
        width: 50,
        height: 50,
        borderRadius: "3px",
        backgroundColor: "#cee0f3",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    itemlogoimg: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        borderRadius: "3px",
    },
    iteminfoimg: {
        display: "inline-flex",
        flexDirection: 'row',
        borderRadius: "20px",
        backgroundColor: "#E2F1FA",
    },
    iteminfo: {
        paddingLeft: 10,
        flex: 1
    },
    itemtitle: {
        fontSize: 12,
        color: "#000",
        marginTop: 5,
    },
    itembudget: {
        fontSize: 10,
        color: "#333",
        marginTop: 4,
    },
    itemtime: {
        fontSize: 10,
        color: "#555",
        marginTop: 4,
    },
    iteminfoicon: {
        width: 10,
        height: 10,
    },
    iteminfotype: {
        fontSize: 10,
        color: "#778E9C",
        //paddingLeft:5,
    },
    daysitem: {
        borderRadius: "3px",
        backgroundColor: "#E2F1FA",
        padding: 8,
        marginTop: 10,
    },
    daystxt1: {
        fontSize: 12,
        color: "#000"
    },
    daystxt2: {
        fontSize: 10,
        color: "#555",
        marginTop: 3
    },
    destination: {
        marginTop: 10
    },
    destinationtxt: {
        fontSize: 13,
        fontWeight: "600",
        color: "#000"
    },
    costtxt: {
        fontSize: 11,
        fontWeight: "600",
        color: "#000",
        marginTop: 10
    },
    itemRight: {
        height: "100%",
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
    },
    itemBtn: {
        borderRadius: "3px",
        backgroundColor: "#004aad",
        color: "#fff",
        padding: "5px 10px",
        fontSize: '10px',
        fontWeight: "600",
        textDecoration: "none"
    },
    MapScreenshotImg:{
        marginTop: 10
    }
});

const PdfDocument = ({ itineraryData, authed, currency, mapImg }) => {
    // console.log(mapImg)
    return (
        <Document author="" title="Travey Club">
            <Page size="LETTER" style={styles.page} wrap>
                <View style={styles.header} wrap={false} fixed>
                    <Image style={styles.headerlogo} source={{ uri: logo }} />
                    <View style={styles.headerinfo}>
                        <Text style={styles.headertxt}>Name: {authed ? authed?.user?.name : "N/A"}</Text>
                        <Text style={styles.headertxt}>Email: {authed ? authed?.user?.email : "N/A"}</Text>
                        <Text style={styles.headertxt}>Date: {itineraryData?.updatedAt ? moment(itineraryData?.updatedAt).format("DD-MM-YYYY") : "N/A"}</Text>
                    </View>
                </View>
                <View wrap={false}>
                    <Text style={styles.costtxt}>Estimated cost: 
                        {itineraryData?.estimated_Cost ? <>{currency} {Math.floor(itineraryData?.estimated_Cost)}</> : "N/A"}
                        </Text>
                </View>
                {!itineraryData ? null : itineraryData?.destinationCityDetails?.map((destinationitem, i) => {
                    return (
                        <>
                            <View style={styles.destination} wrap={false}>
                                <Text style={styles.destinationtxt}>Destination City - {destinationitem?.destination_city?.city.normalize("NFC")}</Text>
                            </View>
                            {destinationitem?.itineraryDatys?.map((daysitem, d) => {
                                return (
                                    <>
                                        <View style={styles.daysitem} wrap={false}>
                                            <Text style={styles.daystxt1}>Day {i > 0 ? dayNumber(i, daysitem?.day, itineraryData) : daysitem?.day}</Text>
                                            <Text style={styles.daystxt2}>{moment(daysitem?.date).format("DD MMMM yyyy")}</Text>
                                        </View>
                                        {daysitem?.itineraryDaysDetails?.sort((a, b) => a.time > b.time ? 1 : -1).map((item, dt) => {
                                            return (
                                                <>
                                                    <View style={styles.itemlist} wrap={false}>
                                                        <View style={styles.itemlogo}>
                                                            <Image style={styles.itemlogoimg} source={{
                                                                uri:
                                                                    getIconForDaysType(item?.days_type, item?.types[0])
                                                            }} />
                                                        </View>
                                                        <View style={styles.iteminfo}>
                                                            <View style={styles.iteminfoimg}><Text style={styles.iteminfotype}>{item?.days_type === "Transports" ? item?.types[0] : item?.days_type}</Text></View>
                                                            <Text style={styles.itemtitle}>{item?.name}</Text>
                                                            {item?.amount === undefined || item?.amount === null ? "" : <Text style={styles.itembudget}>{item?.currencyConvert ? Math.floor(item?.currencyConvert?.new_amount) : Math.floor(item?.amount)} {item?.currencyConvert ? item?.currencyConvert?.new_currency : item?.currency}</Text>}
                                                            <Text style={styles.itemtime}>{item?.time}</Text>
                                                        </View>
                                                        <View style={styles.itemRight}>
                                                            <Link src={
                                                                item?.days_type === "Transports" ?
                                                                    `https://www.google.com/maps/dir/${item?.from_address?.location?.coordinates[0]},${item?.from_address?.location?.coordinates[1]}/${item?.to_address?.location?.coordinates[0]},${item?.to_address?.location?.coordinates[1]}`
                                                                    :
                                                                    `https://www.google.com/maps?q=${item.location?.coordinates[0]},${item.location?.coordinates[1]}`
                                                            }
                                                                style={styles.itemBtn}>Map view</Link>
                                                        </View>
                                                    </View>
                                                </>
                                            )
                                        })}
                                        {/* <Image style={styles.MapScreenshotImg} source={{ uri: mapImg }} /> */}
                                    </>
                                )
                            })}
                        </>
                    )
                })}
                <View style={styles.footer} fixed>
                    <Text >&copy; {new Date().getFullYear()} Travey Club. All Rights Reserved.</Text>
                </View>
            </Page>
        </Document>
    )
}

export default PdfDocument;
